import { Box, Button, Typography } from "@mui/material";
import { FindPlayersIcon } from "../../../assets/icons/MUI/EventsIcons";
import { colors } from "../../../theme/palette";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const FindPlayersFigure = ({
  isOwnEvent,
  isRequests,
  isCanceled,
}: {
  isOwnEvent: boolean;
  isRequests?: boolean;
  isCanceled: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      <FindPlayersIcon style={{ marginBottom: "24px" }} />
      {isOwnEvent && (
        <Typography variant="h5Bold" sx={{ color: colors.Dark1000, display: "block", marginBottom: "17px" }}>
          {t("pages.events.eventDetails.findPlayers")}
        </Typography>
      )}
      <Typography variant="body16Regular" sx={{ color: colors.Dark600, display: "block", marginBottom: "22px" }}>
        {isRequests
          ? t("pages.events.eventDetails.noPlayersRequestsYet")
          : t("pages.events.eventDetails.noPlayerHasJoinedYet")}
      </Typography>
      {isOwnEvent && (
        <Button
          variant="outlined-sm"
          disabled={isCanceled}
          onClick={() => {
            const invitePath = `${location.pathname}/invite`;
            navigate(invitePath);
          }}
          sx={{
            fontFamily: "HeadingNowVarTrial",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
            width: "100%",
            maxWidth: "224px",
          }}
        >
          {t("pages.events.eventDetails.invitePlayers")}
        </Button>
      )}
    </Box>
  );
};

export default FindPlayersFigure;
